module.exports = __webpack_public_path__ + "static/home_scopri4-c451f4c93d591f5d01a42826c6193ef2.jpg";